<script lang="ts">
import bugsnag from '@bugsnag/js';

export const sendErrorReport = (name: string, message: string, data?: object) => {
  if (data) {
    bugsnag.addMetadata('context', data);
  }
  const notify = { name, message };
  bugsnag.notify(notify);

  console.trace('Reported error: ', notify, data);
};
</script>
<script setup lang="ts">
const props = defineProps<{
  name: string;
  message: string;
  data?: object;
}>();
sendErrorReport(props.name, props.message, props.data);
</script>

<template>
  <slot />
</template>
